import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AsPipe } from './as.pipe';
import { DatePipe } from './date.pipe';
import { FilterPipe } from './filter.pipe';
import { FindPipe } from './find.pipe';
import { NestedDataPipe } from './nested-data.pipe';
import { NumberPipe } from './number.pipe';
import { SplitPipe } from './split.pipe';
import { SumPipe } from './sum.pipe';
import { TranslateDeepPipe } from './translate-deep.pipe';
import { ValuesPipe } from './values.pipe';

export * from './values.pipe';
export * from './filter.pipe';
export * from './find.pipe';
export * from './sum.pipe';
export * from './date.pipe';
export * from './nested-data.pipe';
export * from './number.pipe';
export * from './translate-deep.pipe';
export * from './as.pipe';
export * from './split.pipe';

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        AsPipe,
        DatePipe,
        NumberPipe,
        NestedDataPipe,
        TranslateDeepPipe,
        FilterPipe,
        SumPipe,
        FindPipe,
        ValuesPipe,
        SplitPipe,
    ],
    exports: [
        AsPipe,
        DatePipe,
        NumberPipe,
        NestedDataPipe,
        TranslateDeepPipe,
        FilterPipe,
        SumPipe,
        FindPipe,
        ValuesPipe,
        SplitPipe,
    ],
})
export class CorePipesModule {}
